import { Component } from '@angular/core';
import { map } from "rxjs";
import { DocViewerStore } from "@store/legacy/doc-viewer.store";

@Component({
    selector: 'lex-doc-viewer-history-dialog.component.ts',
    templateUrl: './doc-viewer-history-dialog.component.html',
    styleUrls: ['./doc-viewer-history-dialog.component.scss'],
    standalone: false
})
export class DocViewerHistoryDialogComponent {
	public audits$ = this.docViewerStore.simpleState$.pipe(
		map((state) => {
			return state.audits;
		})
	);
  constructor(private docViewerStore: DocViewerStore) { }

}
